<template>
  <v-main class="product_list">
    <h1>软件产品开发案例展示</h1>
    <PlatformSelector @platform-change="handlePlatformChange" />
    <div class="case-container">
      <div class="case-list">
        <CaseList :platform="selectedPlatform" @case-change="handleCaseChange" />
      </div>
      <div class="vertical-divider"> </div>
      <div class="case-detail">
        <CaseDetail :product="selectedCase" />
      </div>
    </div>
  </v-main>
</template>

<script>
import PlatformSelector from '../components/ProductInfo/PlatformSelector.vue'
import CaseList from '../components/ProductInfo/CaseList.vue'
import CaseDetail from '../components/ProductInfo/CaseDetail.vue'

export default {
  name: "ProductsPage",
  components: { PlatformSelector, CaseList, CaseDetail },
  data: () => ({
    selectedPlatform: 'ios',
    selectedCase: null,
  }),
  methods: {
    handlePlatformChange(platform) {
      this.selectedPlatform = platform;
    },
    handleCaseChange(c) {
      this.selectedCase = c;
    }
  },
};
</script>

<style scoped>
.product_list {
  background-image: url("~@/assets/img/bgHero.jpg");
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  text-align: center;
}
h1 {
  color: white;
}
.case-container {
  display: flex;
  margin-left:10%;
  width: 80%;
  margin: 20px;
}
.case-list {
  flex: 1;
  padding: 20px;
}
.vertical-divider {
  width: 2px;
  background-color: white;
  margin: 0 10px;
  flex: 0 0 auto;
}
.case-detail {
  flex: 4;
  padding: 20px;
}
</style>
